export function lastModifiedDate(date: string) {
  return `Última atualização em: ${date}`;
}

export function getSemester(date: Date) {
  return Math.floor(date.getMonth() / 6) === 1 ? 2 : 1;
}
